import type { Review } from "@/types";

const cover1 =
  "https://readdy.ai/api/search-image?query=Cinematic%20moody%20shot%20of%20a%20dense%20dark%20green%20jungle%20canopy%20with%20warm%20amber%20light%20beams%20cutting%20through%20thick%20mist%20atmospheric%20film%20still%20professional%20color%20grading%20subtle%20film%20grain%20simple%20composition%20no%20text%20no%20watermark&width=1200&height=675&seq=jungle-review-1&orientation=landscape";
const cover2 =
  "https://readdy.ai/api/search-image?query=Cinematic%20moody%20shot%20of%20a%20still%20dark%20forest%20green%20jungle%20river%20at%20dawn%20with%20low%20hanging%20mist%20and%20soft%20warm%20amber%20light%20on%20the%20water%20atmospheric%20film%20still%20professional%20color%20grading%20subtle%20film%20grain%20no%20text%20no%20watermark&width=1200&height=675&seq=jungle-review-2&orientation=landscape";
const cover3 =
  "https://readdy.ai/api/search-image?query=Cinematic%20macro%20shot%20of%20rain%20droplets%20on%20deep%20green%20tropical%20leaves%20in%20a%20dark%20moody%20jungle%20with%20soft%20warm%20amber%20highlights%20and%20atmospheric%20haze%20film%20still%20professional%20color%20grading%20subtle%20film%20grain%20no%20text%20no%20watermark&width=1200&height=675&seq=jungle-review-3&orientation=landscape";
const cover4 =
  "https://readdy.ai/api/search-image?query=Cinematic%20moody%20shot%20of%20a%20lone%20dark%20silhouette%20standing%20amid%20dense%20green%20jungle%20foliage%20at%20dusk%20with%20warm%20amber%20backlight%20and%20heavy%20fog%20atmospheric%20film%20still%20professional%20color%20grading%20subtle%20film%20grain%20no%20text%20no%20watermark&width=1200&height=675&seq=jungle-review-4&orientation=landscape";
const cover5 =
  "https://readdy.ai/api/search-image?query=Cinematic%20moody%20shot%20of%20ancient%20moss%20covered%20stone%20ruins%20inside%20a%20dark%20green%20foggy%20tropical%20jungle%20with%20creeping%20vines%20and%20soft%20warm%20amber%20light%20atmospheric%20film%20still%20professional%20color%20grading%20no%20text%20no%20watermark&width=1200&height=675&seq=jungle-review-5&orientation=landscape";
const cover6 =
  "https://readdy.ai/api/search-image?query=Cinematic%20moody%20night%20shot%20of%20a%20warm%20amber%20camp%20lantern%20glowing%20in%20the%20middle%20of%20a%20dark%20green%20misty%20jungle%20surrounded%20by%20foliage%20atmospheric%20film%20still%20professional%20color%20grading%20subtle%20film%20grain%20no%20text%20no%20watermark&width=1200&height=675&seq=jungle-review-6&orientation=landscape";

export const reviews: Review[] = [
  {
    id: "r1",
    title: "《激情丛林》：在失控的绿色迷宫里，重新定义冒险片的呼吸感",
    author: "沈砚",
    source: "《电影手册》中文版",
    date: "2024-10-20",
    rating: 4.5,
    category: "专业影评",
    excerpt:
      "它不急着让你爽，而是逼着你一起喘不上气。陆云舟用几乎偏执的耐心，把“冒险”二字从类型套路里解救出来。",
    cover: cover1,
    tags: ["冒险", "空间叙事", "长镜头"],
    content: [
      "很少有华语冒险片敢于把节奏调得这么慢。开场近二十分钟，《激情丛林》都在做同一件事：让你熟悉这片丛林的颜色、气味与呼吸。它不急着抛出危险，而是先让你相信，这片绿色是活的。",
      "陆云舟最聪明的地方在于，他让“失焦”成为一种叙事手段。镜头经常游离于人物之外，落在叶片上的水珠、泥地里的脚印、远处一闪而过的身影。信息被刻意藏起来，观众的焦虑也就顺理成章地生长出来。",
      "影片真正的高潮并不在动作场面，而在一次近乎静止的对峙。当林深终于开口讲述当年的事，镜头几乎没有移动，只有雨声在变。那一刻你才意识到，前面所有的铺垫都在为这短短几分钟服务。",
      "当然它并非完美。第三幕的信息密度明显偏高，部分解释过于直白。但瑕不掩瑜，《激情丛林》依然是近年少有的、愿意把观众当成成年人对待的冒险电影。",
    ],
  },
  {
    id: "r2",
    title: "当丛林成为主角：论《激情丛林》的空间叙事",
    author: "陆知秋",
    source: "深焦 DeepFocus",
    date: "2024-10-24",
    rating: 4.7,
    category: "剧情解析",
    excerpt:
      "在这部电影里，人物是丛林的注脚，而不是丛林是人物冒险的背景板。它完成了对空间叙事一次大胆而成功的重构。",
    cover: cover2,
    tags: ["空间叙事", "自然", "深度解析"],
    content: [
      "如果把《激情丛林》里的雨林仅仅理解为“场景”，你会错过它大半的野心。影片自始至终在暗示：丛林不是一个被动等待被征服的容器，而是一个有意志、有记忆的主体。",
      "摄影指导罗青野坚持自然光实景拍摄，让光线本身成为叙事的一部分。清晨的柔光是庇护，正午的硬光是审判，暴雨中的散射光则是混乱。人物的处境，几乎完全由光线的性质来定义。",
      "更值得注意的是声音设计。丛林的“静”从来不是无声，而是无数细小声音的叠加：虫鸣、叶响、水滴、远处不明来源的断裂声。当这些声音在某个瞬间集体消失时，观众和角色会同时感到窒息。",
      "因此，当有人说“这部电影节奏慢”时，我反而觉得它信息密度极高，只是它把信息从台词转移到了空间本身。这是一次非常高级的电影语言实验。",
    ],
  },
  {
    id: "r3",
    title: "一场关于贪婪与敬畏的雨林寓言",
    author: "顾南野",
    source: "影迷周刊",
    date: "2024-10-26",
    rating: 4.2,
    category: "专业影评",
    excerpt:
      "赵景行不是传统意义的反派，他更像是一面镜子。电影真正的对手，从来不是某个人，而是那套“什么都可以标价”的逻辑。",
    cover: cover3,
    tags: ["主题解读", "资本", "寓言"],
    content: [
      "《激情丛林》最有价值的处理，是它没有把矛盾简化成“好人对抗坏人”。赵景行的每一句话都合乎商业逻辑，他甚至彬彬有礼。可正是这种文明得体，让人不寒而栗。",
      "影片反复出现的“带走 / 留下”母题，其实指向的是同一种焦虑：我们究竟有什么资格去定义一片土地的价值？苏雨桐想“带走”真相，何清想“带走”证据，赵景行想“带走”资源，而林深只想“留下”。",
      "阿岩这个角色的存在，是整部电影的道德锚点。他不需要台词，只要站在那里，就足以构成对所有人的质问。可惜影片对他着墨略少，算是小小的遗憾。",
      "尽管如此，《激情丛林》依然完成了一次成功的寓言书写。它让一个具体的冒险故事，承载了足够普遍的追问。",
    ],
  },
  {
    id: "r4",
    title: "从地理到心理：林深这条线为什么让人窒息",
    author: "陆知秋",
    source: "深焦 DeepFocus",
    date: "2024-10-28",
    rating: 4.6,
    category: "剧情解析",
    excerpt:
      "陈默贡献了一次极其克制的表演。他几乎不解释自己，却让观众全程站在他的情绪里，这本身就是奇迹。",
    cover: cover4,
    tags: ["人物分析", "表演", "心理"],
    content: [
      "林深第一次出场时，只是一个沉默的向导。他不主动，不热情，甚至显得有些冷漠。但随着旅程推进，你会发现他的每一次沉默，其实都是一次自我防卫。",
      "陈默的表演几乎没有大动作，全靠呼吸、眼神和停顿的细微变化来完成。有一场戏他只是坐在火堆边盯着雨水，什么都没说，你却能从他的肩背线条里读出整整十年的愧疚。",
      "影片把林深的心理曲线与地理曲线几乎完全重叠：越往丛林深处走，他越靠近自己的伤口。当他最终在遗迹前停下脚步时，那一刻既是旅程的终点，也是他终于无处可逃的起点。",
      "这也是我对本片评价最高的部分之一——它相信观众有能力从一个不发一语的人身上，读懂整段历史。",
    ],
  },
  {
    id: "r5",
    title: "配乐与音效：那片会呼吸的丛林",
    author: "声音笔记",
    source: "声音笔记",
    date: "2024-10-30",
    rating: 4.4,
    category: "专业影评",
    excerpt:
      "顾长风把雨林本身录成了乐器。当音乐退场、环境音成为主角时，恐惧才真正开始蔓延。",
    cover: cover5,
    tags: ["配乐", "声音设计", "听觉"],
    content: [
      "《激情丛林》的原声音乐有一个反常规的特点：它出现得极晚。前四十分钟里，真正意义上的主题音乐几乎缺席，取而代之的是海量的环境声采样。",
      "顾长风透露，团队在雨林里录制了数百小时的原声素材，再用竹制乐器进行呼应。于是配乐和自然音之间没有明显边界，你常常分不清那是旋律，还是风穿过树叶的声音。",
      "这种处理带来的直接后果是：当音乐真的响起时，它获得了极强的冲击力。那一小段旋律出现在影片中段，像是一束光，短暂地照亮了灰色的空间。",
      "如果说视觉上《激情丛林》是一场沉浸，那么听觉上它就是一次围困。它不给你逃离的出口，也不允许你分神。",
    ],
  },
  {
    id: "r6",
    title: "走出影院后我沉默了很久",
    author: "小满",
    source: "观众声音",
    date: "2024-11-02",
    rating: 4.8,
    category: "观众声音",
    excerpt:
      "我不是专业影迷，但这是我今年唯一一部看完之后没有立刻刷手机的电影。它在我心里留下了很沉的分量。",
    cover: cover6,
    tags: ["观众", "观后感", "共鸣"],
    content: [
      "我是在雨天走进影院的。散场时外面还在下雨，我撑着伞走了很久，一句话也不想说。那种感觉很难形容，不是难过，也不完全是震撼，更像是被什么东西轻轻压住了。",
      "我不太懂什么长镜头、空间叙事，但我知道，当我看到林深最后那个背影的时候，我整个人是屏住呼吸的。那一刻我好像也走进了那片雨林。",
      "回家的路上我一直在想那句台词：“丛林从不阻止你进来，它只是决定了谁还能出去。”我们是不是也常常在生活里，走进一些再也出不来的地方？",
      "谢谢这部电影。它没有给我答案，但它让我愿意多想一想。",
    ],
  },
  {
    id: "r7",
    title: "摄影解析：自然光下的暗部美学",
    author: "光影手记",
    source: "光影手记",
    date: "2024-11-04",
    rating: 4.3,
    category: "剧情解析",
    excerpt:
      "全片几乎没有人工补光，大量的暗部却丝毫不显脏乱，这是一种极高难度的克制，也是一次审美的胜利。",
    cover: cover1,
    tags: ["摄影", "自然光", "美术"],
    content: [
      "在商业电影普遍追求“亮、透、净”的今天，《激情丛林》选择了一条并不讨巧的路：让暗部真正地暗下去。",
      "罗青野的方法论是“信任自然”。他不补光，不修饰，让光线的方向、强度和颜色完全交给天气与季节。因此同一场景在不同时间拍摄，会呈现出截然不同的情绪。",
      "这种坚持带来了极高的拍摄难度。剧组常常为了等一束合适的光，在泥泞中等待数小时。但也正是这份等待，成就了银幕上那些几乎可以触摸的真实感。",
      "当然，暗部美学对放映环境提出了很高要求。它更适合在大银幕、在足够暗的影厅里观看。这不是缺陷，而是创作者对观看方式的一种坚持。",
    ],
  },
  {
    id: "r8",
    title: "《激情丛林》好在哪？一次反类型片的胜利",
    author: "周礼",
    source: "影评人周礼",
    date: "2024-11-06",
    rating: 4.1,
    category: "专业影评",
    excerpt:
      "它不断给你期待，然后一次次礼貌地拒绝兑现。这种“反类型”的策略，既成就了它，也限制了它。",
    cover: cover2,
    tags: ["类型", "反套路", "评论"],
    content: [
      "商业冒险片的默认契约是：制造危机，解决危机，最后给出一个爽快的宣泄。《激情丛林》几乎每一步都在违背这个契约。",
      "它设置了无数“即将爆发”的时刻，却总是让冲突在最后一秒化为沉默。这种处理让影片获得了罕见的高级感，也让一部分期待类型爽感的观众感到困惑。",
      "我认为这是一种勇敢的选择。当下的电影市场太需要有人愿意冒险，去做一部不那么“好用”的作品。",
      "但客观地说，这种策略也带来了代价：情绪长期处于压抑状态，缺少必要的释放点。它更像一次严肃的体验，而非一次轻松的消费。",
    ],
  },
  {
    id: "r9",
    title: "女性角色书写：苏雨桐不只是被拯救者",
    author: "她看电影",
    source: "她看电影",
    date: "2024-11-08",
    rating: 4.5,
    category: "剧情解析",
    excerpt:
      "在一个以男性为默认主角的类型里，江晚把苏雨桐演成了一个真正意义上的行动者，而不是情节的装饰。",
    cover: cover3,
    tags: ["女性", "人物分析", "表演"],
    content: [
      "冒险片里的女性角色，常常难逃两种命运：被定义成情感线，或者被定义为需要被保护的对象。《激情丛林》难得地避开了这两条老路。",
      "苏雨桐的驱动力从来不是爱情，而是她自己的学术执念。她会犯错，会固执，会在关键时刻做出并不“讨喜”的选择。正是这些不完美，让她成为一个完整的人。",
      "江晚的表演同样值得称道。她没有把角色演成“坚强的符号”，而是保留了大量脆弱与犹豫的瞬间。那些瞬间，反而让她的坚韧显得更有说服力。",
      "当一个女性角色可以独立地承载主题，而不只是服务于男性主角的成长时，这部电影就已经完成了一件了不起的事。",
    ],
  },
  {
    id: "r10",
    title: "三刷之后才看懂的细节",
    author: "阿哲",
    source: "观众声音",
    date: "2024-11-10",
    rating: 4.7,
    category: "观众声音",
    excerpt:
      "第一次看故事，第二次看人物，第三次才发现，原来每一个空镜都是伏笔。导演真的太狠了。",
    cover: cover4,
    tags: ["细节", "彩蛋", "二刷"],
    content: [
      "我第一遍看完只觉得闷，第二遍开始觉得妙，第三遍之后我彻底服了。这部电影的信息量，远远超过它表面给人的印象。",
      "比如开场那只被冲上岸的木箱，我以为只是环境的铺垫，后来才意识到它和结尾的某个镜头形成了完整的呼应。类似的细节，全片至少十几处。",
      "再比如人物的站位，几乎每一场重要对话，谁在前景、谁被挡住，都和他们的权力关系一一对应。这种设计不是炫技，而是真正意义上的“每一帧都为叙事服务”。",
      "所以我想说，如果你第一次看完觉得“也就那样”，请给它第二次机会。它值得。",
    ],
  },
  {
    id: "r11",
    title: "争议与遗憾：第三幕的节奏问题",
    author: "周礼",
    source: "影评人周礼",
    date: "2024-11-12",
    rating: 3.6,
    category: "专业影评",
    excerpt:
      "前两幕的克制在第三幕突然失守。过多的解释和过快的收束，让积累的情绪没有找到最恰当的落点。",
    cover: cover5,
    tags: ["争议", "节奏", "批评"],
    content: [
      "如果说《激情丛林》的前两幕是一次教科书级别的耐心，那么第三幕则暴露了创作者的犹疑。",
      "问题出在“解释太多”。前两幕精心隐藏的信息，在第三幕被集中抛出，不仅节奏陡然加快，也削弱了影片一直引以为傲的暧昧气质。",
      "更让我遗憾的是结尾的处理。历经千辛万苦抵达的情感高点，被一个略显仓促的收束轻轻带过。它本可以更沉默，也更有力量。",
      "当然，这些批评建立在影片整体水准极高的前提之上。指出遗憾，恰恰是因为对它抱有更高的期待。",
    ],
  },
  {
    id: "r12",
    title: "为什么它值得我们反复讨论",
    author: "午夜场",
    source: "观众声音",
    date: "2024-11-15",
    rating: 4.4,
    category: "观众声音",
    excerpt:
      "有些电影看的时候很爽，看完就忘了。而《激情丛林》是那种会在某个下雨的夜晚，突然回到你脑子里的电影。",
    cover: cover6,
    tags: ["讨论", "主题", "观后感"],
    content: [
      "这部电影最厉害的地方，是它拒绝给你一个标准答案。散场之后，你和朋友可以争论两个小时，谁也说服不了谁。",
      "有人说它讲的是贪婪，有人说是救赎，有人说是人与自然的关系。我觉得它同时讲了这些，又不止这些。",
      "好的作品就是这样，它提供一个足够复杂的容器，让不同的观众把自己的经历与困惑装进去。你的答案，其实藏着你自己。",
      "所以它值得反复讨论，也值得反复观看。",
    ],
  },
];

export const reviewCategories = ["全部", "专业影评", "剧情解析", "观众声音"];

export const sortOptions = [
  { key: "rating_desc", label: "评分：高 → 低" },
  { key: "rating_asc", label: "评分：低 → 高" },
  { key: "date_desc", label: "时间：新 → 旧" },
  { key: "date_asc", label: "时间：旧 → 新" },
];